<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">The Giant of <br/>the Beyond</h1><ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li><li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li><li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li><li id="toc-li-4"><a href="#/text/ch004#acknowledgment">Acknowledgment</a></li><li id="toc-li-5"><a href="#/text/ch005#prologue-august-12-2001">Prologue: August 12, 2001</a></li><li id="toc-li-6"><span href="#/text/ch006#chapter-1-hatching-our-plan" title="Link target outside of Sample">Chapter 1: Hatching Our Plan</span></li><li id="toc-li-7"><span href="#/text/ch007#chapter-2-the-query" title="Link target outside of Sample">Chapter 2: The Query</span></li><li id="toc-li-8"><span href="#/text/ch008#chapter-3-schools-out" title="Link target outside of Sample">Chapter 3: School’s Out</span></li><li id="toc-li-9"><span href="#/text/ch009#chapter-4-the-forest" title="Link target outside of Sample">Chapter 4: The Forest</span></li><li id="toc-li-10"><span href="#/text/ch010#chapter-5-the-final-chapter" title="Link target outside of Sample">Chapter 5: The Final Chapter</span></li><li id="toc-li-11"><span href="#/text/ch011#epilogue-2001" title="Link target outside of Sample">Epilogue: 2001</span></li></ol></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?04b1c848